import { routerFrom } from "router";

export const routes = [
  {
    acl: [],
    label: "Job Applications Details",
    name: "job-applications.details",
    path: "/app/job-applications/:jobApplicationId",
  },
  {
    acl: [],
    label: "Job Applications Details Details",
    name: "job-applications.details.details",
    path: `/app/job-applications/:jobApplicationId/?tab=details`,
  },
  {
    acl: [],
    label: "Job Applications Lifecycle",
    name: "job-applications.details.lifecycle",
    path: `/app/job-applications/:jobApplicationId/?tab=lifecycle`,
  },
  {
    acl: [],
    label: "Job Applications Related",
    name: "job-applications.details.related",
    path: `/app/job-applications/:jobApplicationId/?tab=related`,
  },
  {
    acl: [],
    label: "Job Applications Messages",
    name: "job-applications.details.messages",
    path: `/app/job-applications/:jobApplicationId/?tab=messages`,
  },
  {
    acl: [],
    label: "Job Applications List",
    name: "job-applications",
    path: "/app/job-applications",
  },
];

export const router = routerFrom(routes);
